import {batch} from 'react-redux';
import _ from 'lodash';
import * as actiontypes from '../../constants/actionType';
import {hideTypedModal} from './typedModalAction';

export function setTimerInterval(timerInterval) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_TIMER_INTERVAL, timerInterval});
  };
}

export function clearTimerInterval(timerInterval) {
  return (dispatch) => {
    clearInterval(timerInterval);
    dispatch({type: actiontypes.CLEAR_TIMER_INTERVAL});
  };
}

export function setAppModal(modalState) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_APP_MODAL, modalState});
  };
}

export function clearModalError() {
  return {type: actiontypes.CLEAR_MODAL_ERROR};
}

export function showModal(
  header,
  content,
  btnAction,
  onClose,
  // eslint-disable-next-line default-param-last
  className = '',
  // eslint-disable-next-line default-param-last
  closeDisabled = true,
  modalSize,
  // eslint-disable-next-line default-param-last
  style = null,
  confirmationCheckbox,
  isKeepErrorCode,
) {
  console.info(`show ${header} modal`);
  return (dispatch, getState) => {
    const {modalState: currentModalState} = getState();
    const {previousErrorModalState} = currentModalState;

    let {errorCodeNumber} = currentModalState;
    const {actualErrorCodeNumber} = currentModalState;

    const stringifiedPreviousErrorModalContent = JSON.stringify(previousErrorModalState?.content);
    const stringifiedNewContent = JSON.stringify(content);

    if (
      (_.isEqual(stringifiedPreviousErrorModalContent, stringifiedNewContent) &&
        _.isEqual(previousErrorModalState?.header, header)) ||
      isKeepErrorCode
    ) {
      errorCodeNumber = previousErrorModalState?.errorCodeNumber;
    } else if (actualErrorCodeNumber === 0) {
      errorCodeNumber = 0;
    }

    const modalState = {
      header,
      content,
      show: true,
      btnAction,
      onClose,
      className,
      // 04/16/19 (AS) : add closeDisabled
      closeDisabled,
      backdrop: 'static',
      modalSize,
      errorCodeNumber,
      actualErrorCodeNumber,
      style,
      confirmationCheckbox,
    };

    dispatch(hideTypedModal());
    dispatch({type: actiontypes.SET_APP_MODAL, modalState});
  };
}

export function hideModal() {
  return async (dispatch, getState) => {
    const state = getState();

    const {errorCodeNumber, header, content} = state.modalState;

    let modalState = {
      show: false,
      type: '',
    };

    if (errorCodeNumber > 0) {
      modalState = {
        ...modalState,
        actualErrorCodeNumber: 0,
        previousErrorModalState: {
          header,
          content,
          errorCodeNumber,
        },
      };
    }

    const {timerInterval} = state.modalState;

    if (timerInterval) dispatch(clearTimerInterval(timerInterval));
    // only close modal but dont remove the content yet so the modal wont behave weird when closed
    dispatch({type: actiontypes.SET_APP_MODAL, modalState});

    if (state?.typedModalState.isShown) dispatch(hideTypedModal(true));

    setTimeout(() => {
      batch(() => {
        const {modalState: newModalState, modalSetTrayIDState, typedModalState} = getState();

        if (
          ((newModalState.errorCodeNumber !== errorCodeNumber && !newModalState.show) || !newModalState.show) &&
          !modalSetTrayIDState.show &&
          !typedModalState.isShown
        ) {
          dispatch(clearModalError());
        }
      });
    }, 150);
  };
}

export function setModalContent(content) {
  return {type: actiontypes.SET_MODAL_CONTENT, content};
}

export function setModalValid() {
  return {type: actiontypes.SET_MODAL_VALID};
}

export function setModalInvalid() {
  return {type: actiontypes.SET_MODAL_INVALID};
}

export function setModalErrorCode(errorCodeNumber) {
  return {type: actiontypes.SET_MODAL_ERROR_CODE_NUMBER, errorCodeNumber};
}

export const clearPreviousErrorModal = () => ({type: actiontypes.CLEAR_PREVIOUS_ERROR_MODAL});
